module.exports = __webpack_public_path__ + "static/img/3.8f9020b.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/5/1/eng/3.png
// module id = LGKd
// module chunks = 0